<div class="dual-lng-cont">
  <ddc-country-flag class="dual-lng-item" [ddc_lng]="_lng"></ddc-country-flag>
  <ddc-country-flag class="dual-lng-item" [ddc_lng]="_lng2"></ddc-country-flag>
  <ddc-country-flag class="dual-lng-item" [ddc_lng]="_lng3"></ddc-country-flag>
</div>
